import React, { createContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const AccessContext = createContext({
	access: [],
	setAccess: (data) => {},
});
export const AccessContextProvider = ({ children }) => {
	const [access, setAccess] = useState([]);

	const value = useMemo(
		() => ({
			access,
			setAccess,
		}),
		[access],
	);
	return <AccessContext.Provider value={value}>{children}</AccessContext.Provider>;
};
AccessContext.propTypes = {
	children: PropTypes.node.isRequired,
};

export default AccessContext;
